import { TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonWithLoader } from 'components/reusable/button-loader';
import { setAuthData, setMessages } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { twoFactorLogin } from 'store/sagas/sagas';
import { humanDate } from 'utils/ui.utils';
export const TwoFactor = () => {
    const { state, dispatch, asyncDispatch } = useGlobalState();
    const navigate = useNavigate();
    const { otpImage } = state;
    const { otpToken } = state;
    const [userToken, setUserToken] = useState('');
    const updateUserToken = (e) => {
        setUserToken(e.target.value);
    };
    const onSubmit = (event) => {
        event.preventDefault();
        if (userToken) {
            setIsLoading(true);
            void asyncDispatch(twoFactorLogin({ userToken, otpToken }))
                .then((data) => {
                setIsLoading(false);
                if (data.user.loginAt) {
                    dispatch(setMessages({
                        severity: 'info',
                        value: `Last login at ${humanDate(data.user.loginAt)}`
                    }));
                }
                dispatch(setAuthData(data));
                navigate('/account/jobs');
            })
                .finally(() => {
                setIsLoading(false);
            });
        }
    };
    const [isLoading, setIsLoading] = useState(false);
    return (React.createElement("div", { className: "u-align-center" },
        React.createElement("style", null, `
          img {
            max-width: 500px;
          }
          li a {
            margin-left: 0.65em;
          }
        `),
        React.createElement("div", { className: "g-page-without-header-footer" },
            React.createElement("h1", null, "2FA Authentication"),
            otpImage ? (React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("ol", null,
                        React.createElement("li", null,
                            "Install Authy",
                            React.createElement("a", { href: "https://play.google.com/store/apps/details?id=com.authy.authy&hl=en_US", rel: "noreferrer", target: "_blank" }, "Android"),
                            React.createElement("a", { href: "https://apps.apple.com/us/app/authy/id494168017", rel: "noreferrer", target: "_blank" }, "iOS")),
                        React.createElement("li", null, "Add Account"),
                        React.createElement("li", null, "Scan barcode"),
                        React.createElement("li", null, "Enter the 6 digit token"))))) : (React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("ol", null,
                        React.createElement("li", null,
                            "Go to the Authy App",
                            React.createElement("a", { href: "https://play.google.com/store/apps/details?id=com.authy.authy&hl=en_US" }, "Android"),
                            React.createElement("a", { href: "https://apps.apple.com/us/app/authy/id494168017" }, "iOS")),
                        React.createElement("li", null, "Enter the 6 digit token"))))),
            React.createElement("form", { className: "g-form", onSubmit: onSubmit },
                React.createElement("div", null, otpImage ? React.createElement("img", { src: otpImage }) : null),
                React.createElement(TextField, { autoComplete: "one-time-code", className: "g-input-height u-margin-bottom-medium", label: "Token", onChange: updateUserToken, required: true }),
                React.createElement("span", { className: "u-margin-bottom-large u-text-align-right" },
                    "If you do not have access to your two factor auth please contact your organization admin or our",
                    ' ',
                    React.createElement("a", { href: "mailto:support@vouched.id" }, "support"),
                    "."),
                React.createElement(ButtonWithLoader, { disabled: false, isLoading: isLoading, name: "Sign in" })))));
};
